import {
  Flex,
  Button,
  Text,
  Image,
  Divider,
  Card,
  Heading,
} from "@aws-amplify/ui-react";
import StatusCheckComponent from "../../../components/common/StatusCheckComponent";
import { useProfileQuery } from "../../../components/profile/api/useProfileQuery";
import { useUserQuery } from "../../common/useUserQuery";
import ContactAddressCardContent from "./ContactAddressCardContent";
import { useProfileContactQuery } from "../api/useProfileContactQuery";
import ContactEmailPhoneCardContent from "./ContactEmailPhoneCardContent";

export default function AboutMeCard({ onEditClick }) {
  const { data: userQueryData } = useUserQuery();
  const {
    data: profileData,
    isLoading,
    isSuccess,
  } = useProfileQuery(userQueryData?.patientUserId);
  const { data: profileContactData } = useProfileContactQuery(
    userQueryData?.patientUserId
  );
  if (isLoading) {
    return <span>Loading...</span>;
  }

  if (isSuccess) {
    return (
      <Card>
        <Flex
          direction="column"
          justifyContent="flex-start"
          alignItems="flex-start"
          padding="32px 32px 32px 32px"
          backgroundColor="rgba(255,255,255,1)"
        >
          <Button
            size="small"
            variation="primary"
            children="Edit"
            onClick={onEditClick}
          />
          <Flex>
            <Flex gap="8px" direction="column">
              <Text
                fontFamily="Inter"
                fontSize="24px"
                fontWeight="700"
                lineHeight="24px"
                children={profileData?.givenName}
              />
              {profileData?.nickname && (
                <Text>Nickname: {profileData?.nickname}</Text>
              )}
              <Text
                fontFamily="Inter"
                children={`DOB: ${profileData?.dob || ""}`}
              ></Text>
              <Text
                fontFamily="Inter"
                children={`Marital Status: ${profileData?.maritalStatus || ""}`}
              ></Text>
              <Text
                fontFamily="Inter"
                children={`Gender: ${profileData?.gender || ""}`}
              />
            </Flex>
          </Flex>
          <Divider height="1px" size="small" orientation="horizontal" />
          <Heading level="6" children="Contact Info"></Heading>
          <ContactAddressCardContent
            address1={profileContactData?.address1}
            address2={profileContactData?.address2}
            state={profileContactData?.state}
            city={profileContactData?.city}
            zip={profileContactData?.zip}
          />
          <ContactEmailPhoneCardContent
            primaryPhone={
              profileContactData?.primaryDialCode +
              profileContactData?.primaryPhone
            }
            secondaryPhone={
              profileContactData?.secondaryDialCode +
              profileContactData?.secondaryPhone
            }
            workPhone={
              profileContactData?.workDialCode + profileContactData?.workPhone
            }
          />
          <Divider height="1px" size="small" orientation="horizontal"></Divider>
          <StatusCheckComponent
            label={`Last Update: ${profileData?.updatedAt || ""}`}
          />
        </Flex>
      </Card>
    );
  }
}
